export const navigationTypes = {
  sportLive: 'live',
  sportPrematch: 'sport',
  results: 'results',
};
